var map = {
	"./comodo-secure.png": 1284,
	"./flag-france.png": 1285,
	"./flag-germany.png": 1286,
	"./flag-italy.png": 1287,
	"./flag-netherlands.png": 1288,
	"./flag-portugal.png": 1289,
	"./flag-spain.png": 1290,
	"./flag-usa.png": 1291,
	"./global-cart-seal.png": 1292,
	"./icon-wanelo copy.png": 1293,
	"./icon-wanelo.png": 1294,
	"./icon-whatsapp copy.png": 1295,
	"./icon-whatsapp.png": 1296,
	"./lock.png": 1297,
	"./pagamento-cinza.png": 1298,
	"./pagamento-verde.png": 1299,
	"./pagamento-vermelho.png": 1300,
	"./payment-methods-br.png": 1301,
	"./payment-methods-global.png": 1302,
	"./payment-methods.png": 1303,
	"./pedido-cinza.png": 1304,
	"./pedido-verde.png": 1305,
	"./pedido-vermelho.png": 1306,
	"./selo-ebit-ouro.png": 1307,
	"./selo-eureciclo.png": 1308,
	"./selo-internet-segura.png": 1309,
	"./selo-ra1000.png": 1310,
	"./selo_100-seguro-retina.png": 337,
	"./selo_100-seguro.png": 1311,
	"./selo_site_seguro_certisign.png": 1312,
	"./selo_site_seguro_mcafee.png": 1313,
	"./selo_site_seguro_norton.png": 1314,
	"./selo_site_seguro_norton_small.png": 1315,
	"./separacao-cinza.png": 1316,
	"./separacao-verde.png": 1317,
	"./separacao-vermelho.png": 1318,
	"./shipping-methods-global.png": 1319,
	"./transporte-cinza.png": 1320,
	"./transporte-verde.png": 1321,
	"./transporte-vermelho.png": 1322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1283;